import React from 'react';
import styled from 'styled-components';

import { Lead as LeadData } from '../../common/Lead';
import { TrackingClass } from '../../Enums/TrackingClass';

/*
 * Types
 */
type LeadProps = {
    className?: string;
    data: LeadData;
    debug: boolean;
    onClick: (leadData: LeadData) => void;
};

/*
 * Styling
 */
const LeadContainer = styled.div`
    position: relative;
    display: flex;
    background: #ffffff;
    border: 1px solid #949494;
    border-radius: 3px;
    padding: 15px;
    margin-bottom: 15px;
`;

const ImgColumn = styled.div<{ imgUrl: string }>`
    flex: 1;
    background-image: url(${({ imgUrl }) => imgUrl});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    max-width: 108px;
    max-height: 60px;
`;

const TextColumn = styled.div`
    flex: 3;
    font-size: 16px;
    margin-left: 15px;
    line-height: 1.3;

    h1 {
        margin: 0;
        padding: 0;
        font-size: 16px;
        font-weight: bold;
    }

    p {
        margin: 0;
        padding: 0;
    }
`;

const CtaColumn = styled.div`
    width: 7px;
    background-image: url('/img/arrow_right.svg');
    background-repeat: no-repeat;
    background-position: center center;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const DebugCookie = styled.div`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    min-width: 125px;
    color: #fff;
    font-size: 11px;
    text-align: center;
    background-color: #c82d2d;
`;

/*
 * Component
 */
const Lead: React.FC<LeadProps> = (props) => {
    const { className, data, debug, onClick } = props;

    const handleClick = () => {
        if (!onClick) {
            return;
        }

        onClick(data);
    };

    return (
        <LeadContainer onClick={handleClick} className={TrackingClass.CANCEL_CTA} data-leadId={data.leadId}>
            {debug && <DebugCookie>LeadId: {data.leadId}</DebugCookie>}

            <ImgColumn imgUrl={data.image} />

            <TextColumn>
                <h1>{data.title}</h1>
                <p dangerouslySetInnerHTML={{ __html: data.info }} />
            </TextColumn>

            <CtaColumn />
        </LeadContainer>
    );
};

export default Lead;
